import { lazy, Suspense } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SessionRefreshScheduler } from '@/components/session/SessionRefreshScheduler'
import { Toaster } from '@/components/ui/sonner'
import { routes } from '@/router/routes'
import { registerPageRoutes } from '@/router/pagePaths'
import { ThemeProvider } from '@/lib/theme'
import { shouldRetryQuery } from '@/lib/query-retry'

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then(m => ({ default: m.ReactQueryDevtools })),
    )
  : null

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
    },
  },
})

registerPageRoutes(routes)
const router = createBrowserRouter(routes)

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SessionRefreshScheduler />
        <RouterProvider router={router} />
        {ReactQueryDevtools ? (
          <Suspense fallback={null}>
            <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-right' />
          </Suspense>
        ) : null}
        <Toaster position='top-right' richColors />
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
